module.exports = __webpack_public_path__ + "static/img/clause_confirmation132.efe2723.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/book/clause_confirmation132.png
// module id = F++4
// module chunks = 1